module.exports = __webpack_public_path__ + "static/iPhone-2-fea1bf27647adc606372603efb95facf.png";